import React from 'react';
import { motion } from 'framer-motion';
import { Home, MapPin, Shield, FileText, Building2, Key } from 'lucide-react';
const icons = [{
  Icon: Home,
  top: '10%',
  left: '10%',
  delay: 0
}, {
  Icon: MapPin,
  top: '20%',
  right: '15%',
  delay: 1
}, {
  Icon: Shield,
  bottom: '30%',
  left: '5%',
  delay: 2
}, {
  Icon: FileText,
  top: '40%',
  right: '5%',
  delay: 0.5
}, {
  Icon: Building2,
  bottom: '15%',
  right: '20%',
  delay: 1.5
}, {
  Icon: Key,
  bottom: '10%',
  left: '20%',
  delay: 2.5
}];
export function FloatingElements() {
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" data-id="element-8">
      {icons.map((item, index) => <motion.div key={index} className="absolute flex items-center justify-center w-12 h-12 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white/30" style={{
      top: item.top,
      left: item.left,
      right: item.right,
      bottom: item.bottom
    }} animate={{
      y: [0, -15, 0],
      rotate: [0, 5, -5, 0]
    }} transition={{
      duration: 4 + Math.random() * 2,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: item.delay
    }} data-id="element-9">
          <item.Icon className="w-6 h-6" data-id="element-10" />
        </motion.div>)}
    </div>;
}